import React, { Component } from 'react'
import { Util } from '../../../config/Util';
import axios from 'axios';
import { API } from '../../../config/API';
import Loader from '../../../components/Loader/Loader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faClock, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import './EmplHome.css';
import { HiOutlineSpeakerWave } from "react-icons/hi2";
import { HiOutlineBookOpen } from "react-icons/hi2";
import { RiGraduationCapLine } from "react-icons/ri";
import { error } from 'jquery';

export default class EmplHome extends Component {

  constructor() {
    super();

    this.trainingStatus = {
      completed: [],
      pending: [],
      overdue: []
    };
    this.communicationStatus = {
      completed: [],
      pending: [],
      overdue: []
    };
    this.assessmentStatus = {
      completed: [],
      pending: [],
      overdue: []
    };
    this.state = {
      loader: false,
      training: {
        nc: 0,
        c: 0,
        od: 0
      },
      communication: {
        nc: 0,
        c: 0,
        od: 0
      },
      assessment: {
        nc: 0,
        c: 0,
        od: 0
      }
    }
  }


  componentDidMount() {
    const userId = Util.userId;
    this.setState({ loader: true });
    axios.get(API.getUserDetail + userId).then((response) => {
      if (response.status === 200 && response.data.status === 'S') {  
         console.log(response.data);
         Util.saveToSession("userData", response?.data);
         // notify other components that userData in session changed
         try {
           window.dispatchEvent(new Event('userDataUpdated'));
         } catch (e) {
           // noop for environments that don't support Window event dispatch
         }
      }else{
        console.error("Failed to fetch user data:", response.data.message);
       // Util.clearSession("userData");
      }
     
    }).catch(error => {
      console.error("Error fetching user data:", error);  
      this.setState({ loader: false });
      //Util.clearSession("userData");
    }).finally(() => {
       this.findNumbersOfTraining();
        this.findNumbersOfCommunication();
        this.findNumbersOfAssessment();
      this.setState({ loader: false })  
    });




   
  }

  findNumbersOfAssessment = () => {
    let completedT = [];
    let pendingT = [];
    let overdueT = [];
    const data = Util.getFromSession("userData");
    const assessments = data.assessments || [];
    assessments.forEach(element => {
      if (element.status === 'NotCompleted' || element.status === 'Failed') {
        //check due date
        if (new Date() > new Date(element.dueDate)) {
          overdueT.push(element);
        } else {
          pendingT.push(element);
        }
      } else if (element.status === 'Completed') {
        completedT.push(element);
      }
    });
    const obj = {
      nc: pendingT.length,
      c: completedT.length,
      od: overdueT.length
    }
    this.assessmentStatus.completed = completedT;
    this.assessmentStatus.pending = pendingT;
    this.assessmentStatus.overdue = overdueT;
    console.log("Assessment Status:", obj);
    this.setState({ assessment: obj })
  }
  findNumbersOfTraining = () => {
    let completedT = [];
    let pendingT = [];
    let overdueT = [];
    const data = Util.getFromSession("userData");
    const trainings = data.trainings || [];
    trainings.forEach(element => {
      if (element.status === 'NotCompleted' || element.status === 'Failed') {
        //check due date
        if (new Date() > new Date(element.dueDate)) {
          overdueT.push(element);
        } else {
          pendingT.push(element);
        }
      } else if (element.status === 'Completed') {
        completedT.push(element);
      }
    });
    const obj = {
      nc: pendingT.length,
      c: completedT.length,
      od: overdueT.length
    }
    this.trainingStatus.completed = completedT;
    this.trainingStatus.pending = pendingT;
    this.trainingStatus.overdue = overdueT;

    this.setState({ training: obj })
  }

  findNumbersOfCommunication = () => {
    let completedT = [];
    let pendingT = [];
    let overdueT = [];
    const data = Util.getFromSession("userData");
    const communication = data.communications || [];
    communication.forEach(element => {
      if (element.status === 'NotCompleted' || element.status === 'Failed') {
        //check due date
        if (new Date() > new Date(element.dueDate)) {
          overdueT.push(element);
        } else {
          pendingT.push(element);
        }
      } else if (element.status === 'Completed') {
        completedT.push(element);
      }
    });
    const obj = {
      nc: pendingT.length,
      c: completedT.length,
      od: overdueT.length
    }
    this.communicationStatus.completed = completedT;
    this.communicationStatus.pending = pendingT;
    this.communicationStatus.overdue = overdueT;

    this.setState({ communication: obj })
  }

  render() {
    return (
      <div>
        <Loader loading={this.state.loader}></Loader>
        <div className='bread-crumb overflow-auto'>
          <div>
            <span className='breadcrumb-title'>
              <input type='button' className='btn' value='Home'></input>
            </span>

          </div>
        </div>
        <div className='mt-4 mb-5'>
          <div className='row m-auto empl-overview'>
            <div className="card col-lg-4 col-md-4" >
              <div className="card-body completed">
                <div className="card-title mb-4 ">
                  <div className='emp-card-icon'>
                    <span><FontAwesomeIcon icon={faCheckCircle} /></span>
                  </div>
                  <h4>COMPLETED : <span>{this.state.training.c + this.state.communication.c + this.state.assessment.c}</span></h4>
                </div>
                <div className='card-detail-block'>
                  <div className='emp-detail-block'>
                    <div className='detail-icon'>
                      <span><HiOutlineSpeakerWave /></span>
                    </div>
                    <div className='emp-detail-count'>
                      <p>Communication : </p>
                      <h6>{this.communicationStatus.completed.length}</h6>
                    </div>
                  </div>
                  <div className='emp-detail-block'>
                    <div className='detail-icon'>
                      <span><HiOutlineBookOpen /></span>
                    </div>
                    <div className='emp-detail-count'>
                      <p>Training : </p>
                      <h6>{this.trainingStatus.completed.length}</h6>
                    </div>
                  </div>
                  <div className='emp-detail-block'>
                    <div className='detail-icon'>
                      <span><RiGraduationCapLine /></span>
                    </div>
                    <div className='emp-detail-count'>
                      <p>Assessment : </p>
                      <h6>{this.assessmentStatus.completed.length}</h6>
                    </div>
                  </div>
                  {/* <p>Communication : {this.communicationStatus.completed.length}</p>
                  <p>Training : {this.trainingStatus.completed.length}</p>
                  <p>Assessment : {this.assessmentStatus.completed.length}</p> */}
                </div>
              </div>
            </div>
            <div className="card card col-lg-4 col-md-4" >
              <div className="card-body pending">
                <div className="card-title mb-4 ">
                  <div className='emp-card-icon'>
                    <span><FontAwesomeIcon icon={faClock} /></span>
                  </div>
                  <h4>PENDING : <span>{this.state.training.nc + this.state.communication.nc + this.state.assessment.nc}</span></h4>
                </div>
                {/* <p className="card-text pending"></p> */}
                <div className='card-detail-block'>
                  <div className='emp-detail-block'>
                    <div className='detail-icon'>
                      <span><HiOutlineSpeakerWave /></span>
                    </div>
                    <div className='emp-detail-count'>
                      <p>Communication : </p>
                      <h6>{this.communicationStatus.pending.length}</h6>
                    </div>
                  </div>
                  <div className='emp-detail-block'>
                    <div className='detail-icon'>
                      <span><HiOutlineBookOpen /></span>
                    </div>
                    <div className='emp-detail-count'>
                      <p>Training : </p>
                      <h6>{this.trainingStatus.pending.length}</h6>
                    </div>
                  </div>
                  <div className='emp-detail-block'>
                    <div className='detail-icon'>
                      <span><RiGraduationCapLine /></span>
                    </div>
                    <div className='emp-detail-count'>
                      <p>Assessment : </p>
                      <h6>{this.assessmentStatus.pending.length}</h6>
                    </div>
                  </div>
                  {/* <p>Communication : {this.communicationStatus.pending.length}</p>
                  <p>Training : {this.trainingStatus.pending.length}</p>
                  <p>Assessment : {this.assessmentStatus.pending.length}</p> */}
                </div>
              </div>
            </div>
            <div className="card card col-lg-4 col-md-4" >
              <div className="card-body overdue">
                <div className="card-title mb-4 ">
                  <div className='emp-card-icon'>
                    <span><FontAwesomeIcon icon={faExclamationCircle} /></span>
                  </div>
                  <h4>OVERDUE : <span>{this.state.training.od + this.state.communication.od + this.state.communication.od}</span></h4>
                </div>
                {/* <p className="card-text overdue"></p> */}
                <div className='card-detail-block'>
                  <div className='emp-detail-block'>
                    <div className='detail-icon'>
                      <span><HiOutlineSpeakerWave /></span>
                    </div>
                    <div className='emp-detail-count'>
                      <p>Communication : </p>
                      <h6>{this.communicationStatus.overdue.length}</h6>
                    </div>
                  </div>
                  <div className='emp-detail-block'>
                    <div className='detail-icon'>
                      <span><HiOutlineBookOpen /></span>
                    </div>
                    <div className='emp-detail-count'>
                      <p>Training : </p>
                      <h6>{this.trainingStatus.overdue.length}</h6>
                    </div>
                  </div>
                  <div className='emp-detail-block'>
                    <div className='detail-icon'>
                      <span><RiGraduationCapLine /></span>
                    </div>
                    <div className='emp-detail-count'>
                      <p>Assessment : </p>
                      <h6>{this.assessmentStatus.overdue.length}</h6>
                    </div>
                  </div>
                  {/* <p>Communication : {this.communicationStatus.overdue.length}</p>
                  <p>Training : {this.trainingStatus.overdue.length}</p>
                  <p>Assessment : {this.assessmentStatus.overdue.length}</p> */}
                </div>
              </div>
            </div>
          </div>


        </div>
      </div>
    )
  }
}
